<template>
  <div class="row" id="supInforme">
    <div class="col-sm-6 col-12">
      <b-card title="Avance Diario" sub-title="Ingrese los datos solicitados">
        <div class="row">
          <div class="col">Subcuenca</div>
          <div class="col-5">
            <b-form-input
              style="margin-left: -20px;width: 100%"
              v-model="subcuenca"
              @change="() => {
                  show = false;
                  ShowTramo = false;
                }
              "
              type="text"
              placeholder="Ingrese subcuenca"
            />
          </div>
          <div class="col">
            <vs-button class="float-right" @click="getTramos"
              >Aceptar</vs-button
            >
          </div>
        </div>
        <div v-show="ShowTramo">
          <hr style="border-color:red;" />
          <div class="row">
            <div class="col">
              <vs-select
                @change="show = false"
                v-if="inData"
                v-model="Tramo"
                autocomplete
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in optionTramo"
                />
              </vs-select>
              <vs-input v-else v-model="Tramo"></vs-input>
            </div>
            <div class="col">
              <vs-button class="float-right" @click="showForm"
                >Aceptar</vs-button
              >
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <div class="col-sm-6 col-12">
      <form-sup-informe :subcuenca="subcuenca" :tramo="Tramo" :show-card="show"> </form-sup-informe>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */

import FormSupInforme from "./form-supInforme";
import Http from "../Http";
export default {
  name: "supInforme",
  components: { FormSupInforme },
  data: () => ({
    show: false,
    subcuenca: null,
    ShowTramo: false,
    Tramo: null,
    Tramos: [],
    inData: true
  }),
  computed: {
    optionTramo() {
      return this.Tramos.map(x => ({
        value: x.tramo_identifica,
        text: x.tramo_identifica
      }));
    }
  },
  methods: {
    showForm() {
      if (this.Tramo != null) {
        this.show = true;
      }
    },
    getTramos() {
      if (this.subcuenca != null) {
        Http.Http()
          .get(`Preinf/Tramos/${this.subcuenca}`)
          .then(resp => {
            this.ShowTramo = true;
            this.Tramos = resp.data;
            this.inData = resp.data.length > 0;
          })
          .catch(err => console.log(err));
      }
    }
  }
};
</script>

<style scoped></style>
